import axios from "axios";
import moment from 'moment';
export default {
  namespaced: true,
  state: {
    deudas: null,
    reporteDeudas: []
  },
  mutations: {
    llenarDeudas(state, data) {
      state.deudas = data;
      // state.ventas.push(data);
    },
    llenarReporte(state, data) {
      state.reporteDeudas = data;
    },
  },
  actions: {
    getDeudas: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      await axios
        .get('deuda/list',configuracion)
        .then(function(response) {
          response.data.forEach( (element) => {
            element.createdAt = moment(element.createdAt).format("LL");
            if(element.fecha) {
              element.fecha = moment(element.fecha).format("LL");
            }
          })
          data = response.data;
          commit("llenarDeudas", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getReporte: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      await axios
        .get("deuda/grafico12meses", configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarReporte", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  }
};
